import React, { Fragment, useState, useEffect } from 'react'
import { Stepper, Button, Group, TextInput, Radio, Title, Text, Select, CloseButton, Notification, Textarea, Collapse, Tooltip, Modal } from '@mantine/core';
import { DateInput } from '@mantine/dates';
import { MdOutlineAlternateEmail, MdOutlinePhoneEnabled, MdOutlineDateRange } from "react-icons/md";
import { Link, useNavigate } from 'react-router-dom';
import { GrDocumentText } from "react-icons/gr";
import { AiOutlineArrowDown } from "react-icons/ai";
import UploadFile from '../../shared/UploadFile';
import { useSelector } from 'react-redux';
import { getData, postData } from 'views/Website/services/fetch-service';
import { FaCheck, FaInfoCircle } from "react-icons/fa";
import * as Yup from 'yup';
import { useFormik } from 'formik';
import Values from './Values';
import CopyToClipboard from 'react-copy-to-clipboard';
import { RxCross1 } from 'react-icons/rx';
import dayjs from 'dayjs';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

const Sinjalizimi = () => {
    const [active, setActive] = useState(0);
    const prevStep = () => setActive((current) => (current > 0 ? current - 1 : current));
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [permbajtja, setPermbajtja] = useState([]);
    const [epilogu, setEpilogu] = useState([]);
    const [idSinjalizimi, setIdSinjalizimi] = useState();
    const [referenceSinjalizimi, setReferenceSinjalizimi] = useState();
    const baseUrl = process.env.REACT_APP_BASEURL
    const [tooltipVisible, setTooltipVisible] = useState(false);
    const WebsiteLanguage = useSelector((state) => state.WebsiteLanguage.data.language);
    const GeneralTranslations = useSelector((state) => state.WebsiteLanguage.data.GeneralTranslations);
    const ControlsTranslations = useSelector((state) => state.WebsiteLanguage.data.ControlsTranslations);
    const ContentTranslations = useSelector((state) => state.WebsiteLanguage.data.ContentTranslations);
    const ValidationTranslations = useSelector((state) => state.WebsiteLanguage.data.ValidationTranslations);
    const AlertTranslations = useSelector((state) => state.WebsiteLanguage.data.AlertTranslations);
    const [openedd, setOpened] = useState(true);
    const [openedZyrtari, setOpenedZyrtari] = useState(true);
    const [zyrtariList, setZyrtariList] = useState([]);
    const [emriList, setEmriList] = useState('');
    const [mbimeriList, setMbiemriList] = useState('');
    const [nrtelList, setNrTelList] = useState('');
    const [emailList, setEmailList] = useState('');
    const [gjiniaList, setGjiniaList] = useState('');
    const [instutucioniList, setInstituconiList] = useState(null);
    const [instutucioniTjeterList, setInstutucioniTjeterList] = useState('');
    const [pozitaPunesList, setPozitaPunesList] = useState('')

    const [emriError, setEmriError] = useState(false);
    const [mbimeriError, setMbiemriError] = useState(false);
    const [emailError, setEmailError] = useState(false);
    const [gjiniaError, setGjiniaError] = useState(false);
    const [instutucioniError, setInstituconiError] = useState(false);
    const [instutucioniTjeterError, setInstutucioniTjeterError] = useState(false);
    const [pozitaPunesError, setPozitaPunesError] = useState(false)

    const handleCloseButtonClick = () => {
        setNotificationBox(null);
    }

    const fetchPermbajtja = async () => {
        try {
            const response = await getData(`Home/GetPermbajtjaSinjalizimit`);
            if (response.data) {
                setPermbajtja(response.data);
            }
        } catch (error) {
            setPermbajtja();

        }
    }

    const fetchEpilogu = async () => {
        try {
            const response = await getData(`Home/GetSinjalizimiEpilogu`);
            if (response.data) {
                setEpilogu(response.data);
            }
        } catch (error) {
            setEpilogu();

        }
    }

    let nameLocale = '';
    let pershkrimiLocale = '';
    let othersLocale = '';

    if (WebsiteLanguage === 'sq') {
        nameLocale = 'nameSq';
        pershkrimiLocale = 'pershkrimiSq';
        othersLocale = 'Tjetër';
    } else if (WebsiteLanguage === 'en') {
        nameLocale = 'nameEn';
        pershkrimiLocale = 'pershkrimiEn';
        othersLocale = 'Other';
    } else if (WebsiteLanguage === 'sr') {
        nameLocale = 'nameSr';
        pershkrimiLocale = 'pershkrimiSr';
        othersLocale = 'Ostalo';
    } else {
        nameLocale = 'nameSq';
        pershkrimiLocale = 'pershkrimiSq';
        othersLocale = 'Tjetër';
    };

    useEffect(() => {
        fetchPermbajtja();
        fetchEpilogu();
    }, []);

    const institutionsData = useSelector((state) => state.WebsiteLanguage.data.Instuticionet);
    const getValidationSchema = (activeStep) => {
        if (activeStep === 0) {
            return Yup.object().shape({
                raportuesiEmri: Yup.string().required(ValidationTranslations.requiredField),
                raportuesiMbiemri: Yup.string().required(ValidationTranslations.requiredField),
                raportuesiEmail: Yup.string().email(ValidationTranslations.validEmail).required(ValidationTranslations.requiredField),
                ConfirmEmailRaportuesi: Yup.string().email(ValidationTranslations.validEmail)
                    .oneOf([Yup.ref('raportuesiEmail'), null], ValidationTranslations.confirmEmail)
                    .required(ValidationTranslations.requiredField),
                raportuesiGjiniaId: Yup.string().required(ValidationTranslations.requiredField),
                raportuesiInstitucioniId: Yup.string().required(ValidationTranslations.requiredField),
                raportuesiInstitucioniTjera: Yup.string().when('raportuesiInstitucioniId', {
                    is: '-1',
                    then: Yup.string().required(ValidationTranslations.requiredField),
                    otherwise: Yup.string(),
                }),
            });
        } else if (activeStep === 1) {
            return Yup.object().shape({
                permbajtjaSinjalizimiId: Yup.string().required(ValidationTranslations.requiredField),
                sinjalizimiBrendshemKryer: Yup.string().required(ValidationTranslations.requiredField),
                SinjalizimitEshteBereTe: Yup.string().when('sinjalizimiBrendshemKryer', {
                    is: 'true',
                    then: Yup.string().required(ValidationTranslations.requiredField),
                    otherwise: Yup.string(),
                }),
                epiloguId: Yup.string().nullable().when('sinjalizimiBrendshemKryer', {
                    is: true,
                    then: Yup.string().required(ValidationTranslations.requiredField),
                    otherwise: Yup.string().nullable(),
                }),
            });
        }

        return Yup.object();
    };

    const institutionsDataWithStringValues = institutionsData.map(item => ({
        value: `${item.id}`,
        label: item[nameLocale],
    }));

    institutionsDataWithStringValues.push({
        value: '-1',
        label: othersLocale
    });

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const handleEmailChange = (e) => {
        const email = e.target.value;
        setEmailList(email);
        if (!validateEmail(email)) {
            setEmailError(true);
        } else {
            setEmailError(false);
        }
    };

    const handlePopup = () => {
        navigate('/');
    };

    const handlePaste = (event) => {
        event.preventDefault();
        return false;
    };

    const formik = useFormik({
        initialValues: {
            raportuesiEmri: '',
            raportuesiMbiemri: '',
            raportuesiNrTel: '',
            raportuesiEmail: '',
            ConfrimEmailRaportuesi: '',
            raportuesiGjiniaId: '',
            raportuesiInstitucioniId: '',
            raportuesiInstitucioniTjera: '',
            permbajtjaSinjalizimiId: '',

            sinjalizimiBrendshemKryer: '',
            SinjalizimitEshteBereTe: '',
            epiloguId: null,
            sinjalizimiBrendshemPaKryerKoment: '',
        },
        validationSchema: getValidationSchema(active),
        onSubmit: (values) => {
            let controlRaportuesiInstitucioniId = values;
            if (values.raportuesiInstitucioniId === '-1') {
                controlRaportuesiInstitucioniId = { ...values, raportuesiInstitucioniId: null }
            }
            let controlSinjalizimieshetBere = controlRaportuesiInstitucioniId
            if (values.SinjalizimitEshteBereTe === '1') {
                controlSinjalizimieshetBere = { ...controlRaportuesiInstitucioniId, perZyrtarPergjegjes: true, perPunedhenes: null }
            } else if (values.SinjalizimitEshteBereTe === '2') {
                controlSinjalizimieshetBere = { ...controlRaportuesiInstitucioniId, perPunedhenes: true, perZyrtarPergjegjes: null }
            }
            let controlSijalizimiBrenshemKryes = controlSinjalizimieshetBere;
            if (values.sinjalizimiBrendshemKryer === 'true') {
                controlSijalizimiBrenshemKryes = { ...controlSinjalizimieshetBere, sinjalizimiBrendshemKryer: true }
            } else if (values.sinjalizimiBrendshemKryer === 'false') {
                controlSijalizimiBrenshemKryes = { ...controlSinjalizimieshetBere, sinjalizimiBrendshemKryer: false }
            }
            let dateSinjalizimit = controlSijalizimiBrenshemKryes
            if (values.dataSinjalizimit) {
                const formattedDate = dayjs(values.dataSinjalizimit).format('YYYY-MM-DD');
                dateSinjalizimit = { ...controlSijalizimiBrenshemKryes, dataSinjalizimit: `${formattedDate}` };
            } else {
                dateSinjalizimit = { ...controlSijalizimiBrenshemKryes, dataSinjalizimit: null };
            }
            let zyrtariData = dateSinjalizimit
            if (zyrtariList.length > 0) {
                zyrtariData = { ...dateSinjalizimit, sinjalizimiZyrtaret: zyrtariList }
            }
            postSinjalizimi(zyrtariData)
        },
    });

    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedFileError, setSelectedFileError] = useState(false);
    const [documentName, setDocumentName] = useState('');
    const [documentType, setDocumentType] = useState('');
    const [savedDocuments, setSavedDocuments] = useState([]);
    const [documentsModelOpen, setDocumentsModelOpen] = useState(false);
    const [deleteDocumentsIndex, setDeleteDocumentsIndex] = useState(null);

    const [NotificationBox, setNotificationBox] = useState(null);
    const [languageValue, setLanguageValue] = useState(1);
    const [checkMediaError, setCheckMediaError] = useState(false);

    useEffect(() => {
        const languageMap = {
            'sq': 1,
            'en': 2,
            'sr': 3
        };

        setLanguageValue(languageMap[WebsiteLanguage]);
    }, [WebsiteLanguage]);

    const handleFileChange = async (file) => {
        try {
            const lastDotIndex = file.name.lastIndexOf('.');
            const fileType = file.name.slice(lastDotIndex);

            const checkMedia = await getData(`Deklarimi/CheckMedia?size=${file.size}&format=${fileType}&webLang=${languageValue}`);

            if (checkMedia && checkMedia.status === 200) {
                setSelectedFile(file);
            } else {
                setCheckMediaError(true);
                setSelectedFileError(true);
                throw new Error('Error invalid file');
            }
        } catch (error) {
            setCheckMediaError(true);
            setSelectedFileError(true);
            setNotificationBox(
                <Notification icon={<RxCross1 />} color="red" onClose={handleCloseButtonClick}>
                    {AlertTranslations.CheckMediaErrorAlert}
                </Notification>
            );
            setTimeout(() => {
                setNotificationBox(null);
                setCheckMediaError(false);
                setSelectedFileError(false);
            }, 5000);
            setSelectedFile(null);
        }
    };

    const handleSave = async () => {
        try {
            if (selectedFile && documentName) {
                const updatedFile = new Blob([selectedFile], { type: selectedFile.type });
                updatedFile.name = documentName + documentType;

                const newDocument = {
                    file: updatedFile,
                };

                setSavedDocuments((prevDocuments) => [...prevDocuments, newDocument]);
                setSelectedFile(null);
                setDocumentName('');
                setDocumentType('');
                setSelectedFileError(false);
            }
        } catch (error) {
            setSelectedFile(null);
            setDocumentName('');
            setDocumentType('');
            setSelectedFileError(false);

            if (error.response && error.response.data) {
                setNotificationBox(
                    <Notification icon={<RxCross1 />} color="red" onClose={handleCloseButtonClick}>
                        {error.response.data[0].message}
                    </Notification>
                );
                setTimeout(() => {
                    setNotificationBox(null);
                }, 5000);
            }
        }
    };

    const [zyrtariModalOpen, setZyrtariModalOpen] = useState(false);
    const [deleteZyrtariIndex, setDeleteZyrtariIndex] = useState(null);

    const handleSaveZyrtari = () => {
        if (emriList === '') {
            setEmriError(true)
        }
        if (mbimeriList === '') {
            setMbiemriError(true)
        }
        if (gjiniaList === '') {
            setGjiniaError(true)
        }
        if (emailList === '') {
            setEmailError(false)
        }
        if (instutucioniList === null) {
            setInstituconiError(true)
        }
        if (instutucioniTjeterList === '') {
            setInstutucioniTjeterError(true)
        }
        if (pozitaPunesList === '') {
            setPozitaPunesError(true)
        }
        if (
            emriList !== '' &&
            mbimeriList !== '' &&
            gjiniaList !== '' &&
            emailError === false &&
            pozitaPunesList !== '' &&
            instutucioniList?.id !== null &&
            (instutucioniList?.id !== '-1' || (instutucioniList?.id === '-1' && instutucioniTjeterList !== ''))
        ) {
            const newZyrtar = {
                emri: emriList,
                mbiemri: mbimeriList,
                nrTel: nrtelList,
                email: emailList,
                gjiniaId: gjiniaList,
                institucioniId: instutucioniList?.id === '-1' ? null : instutucioniList?.id,
                institucioniName: instutucioniList?.id === '-1' ? null : instutucioniList?.label,
                institucioniTjera: instutucioniTjeterList,
                pozitaPunes: pozitaPunesList,
            };
            setZyrtariList((prevZyrtari) => [...prevZyrtari, newZyrtar]);
            setEmriList('');
            setMbiemriList('');
            setNrTelList('');
            setEmailList('');
            setGjiniaList('');
            setInstituconiList(null);
            setInstutucioniTjeterList('');
            setPozitaPunesList('');
        }
    };

    const handleDeleteZyrtari = (index) => {
        setDeleteZyrtariIndex(index);
        setZyrtariModalOpen(true);
    };

    const confirmDeleteZyrtari = () => {
        if (deleteZyrtariIndex !== null) {
            const updatedZyrtari = [...zyrtariList];
            updatedZyrtari.splice(deleteZyrtariIndex, 1);
            setZyrtariList(updatedZyrtari);
        }
        closeModalZyrtari();
    };

    const closeModalZyrtari = () => {
        setZyrtariModalOpen(false);
        setDeleteZyrtariIndex(null);
    };

    const postSinjalizimi = async (data) => {
        try {
            const newData = {
                ...data,
                Gjuha: WebsiteLanguage,
            }
            const sinjalizimiResponse = await postData('Signals/CreateSignals', newData);
            if (sinjalizimiResponse) {
                setIdSinjalizimi(sinjalizimiResponse.data.raportimets[0].id)
                setReferenceSinjalizimi(sinjalizimiResponse.data.raportimets[0].referenca)
                setIsLoading(false);
            }
        } catch (error) {
            setIsLoading(false);
            setNotificationBox(
                <Notification icon={<RxCross1 />} color="red" onClose={handleCloseButtonClick}>
                    {AlertTranslations.notifyError}
                </Notification>
            );
            setTimeout(() => {
                setNotificationBox(null);
            }, 3000);
        }
    };

    const postSinjalizimiMedia = async () => {
        try {

            const data = {
                Files: savedDocuments,
                RaportimiId: idSinjalizimi,
            };

            let formData = new FormData();
            data.Files.forEach((doc) => {
                formData.append('Files', doc.file, doc.file.name);
            });

            formData.append('RaportimiId', data.RaportimiId);
            formData.append('Publik', true);

            const sinjalizimiResponseMedia = await postData('Deklarimi/InsertRaportimetMedia', formData);

            if (sinjalizimiResponseMedia) {
                setIsLoading(false);
            }

        } catch (error) {
            setIsLoading(false);
            setNotificationBox(
                <Notification icon={<RxCross1 />} color="red" onClose={handleCloseButtonClick}>
                    {AlertTranslations.notifyError}
                </Notification>
            );
            setTimeout(() => {
                setNotificationBox(null);
            }, 5000);
        }
    };

    useEffect(() => {
        if (idSinjalizimi && savedDocuments && savedDocuments.length > 0) {
            postSinjalizimiMedia();
        }
    }, [idSinjalizimi, savedDocuments]);

    const handleNextStep = async () => {
        formik.validateForm().then((errors) => {
            if (Object.keys(errors).length === 0) {
                if (active === 0) {
                    if (zyrtariList.length === 0) {
                        setEmriError(true);
                        setMbiemriError(true);
                        setGjiniaError(true);
                        setInstituconiError(true);
                        setPozitaPunesError(true);
                        setNotificationBox(
                            <Notification icon={<RxCross1 />} color="red" onClose={handleCloseButtonClick}>
                                {AlertTranslations.notifyZyrtari}
                            </Notification>
                        );
                        setTimeout(() => {
                            setNotificationBox(null);
                        }, 3000);
                        return;
                    }
                }

                if (active === 1) {
                    if (selectedFile && !savedDocuments.some((doc) => doc.file === selectedFile)) {
                        setSelectedFileError(true);
                        setNotificationBox(
                            <Notification icon={<RxCross1 />} color="red" onClose={handleCloseButtonClick}>
                                {AlertTranslations.notifyFileRequired}
                            </Notification>
                        );
                        setTimeout(() => {
                            setNotificationBox(null);
                        }, 3000);
                        return;
                    }

                    setIsLoading(true);
                    formik.handleSubmit();
                    setTimeout(() => {
                        setActive(2);
                    }, 3000);
                } else if (active < 2 && zyrtariList.length > 0) {
                    setActive((current) => current + 1);
                }
            } else {
                formik.setTouched(
                    Object.keys(formik.values).reduce((acc, key) => {
                        acc[key] = true;
                        return acc;
                    }, {})
                );
            }
        });
    };

    const handleDelete = (index) => {
        setDeleteDocumentsIndex(index);
        setDocumentsModelOpen(true);
    };

    const confirmDeleteDocuments = () => {
        if (deleteDocumentsIndex !== null) {
            const updatedDocuments = [...savedDocuments];
            updatedDocuments.splice(deleteDocumentsIndex, 1);
            setSavedDocuments(updatedDocuments);
        }
        closeModalDocuments();
    };

    const closeModalDocuments = () => {
        setDocumentsModelOpen(false);
        setDeleteDocumentsIndex(null);
    };

    useEffect(() => {
        if (selectedFile) {
            const lastDotIndex = selectedFile.name.lastIndexOf('.');
            const nameWithoutExtension = selectedFile.name.slice(0, lastDotIndex);
            const fileType = selectedFile.name.slice(lastDotIndex);
            setDocumentName(nameWithoutExtension);
            setDocumentType(fileType);
        }
    }, [selectedFile])

    const clearInputValue = () => {
        setDocumentName('');
        setDocumentType('');
        setSelectedFile(null);
        setSelectedFileError(false);
    };

    const maxChars = 2500;

    return (
        <div className="apk-home">
            <div className="stepper-container">
                <div className="stepper-header">

                    <Stepper allowNextStepsSelect={false} color="#051A53" active={active} onStepClick={setActive}>
                        <Stepper.Step label={ContentTranslations.step1Name} description={ContentTranslations.sinjalizimiStepDescription}>
                            <div className="form-container">
                                <div className="form-section">
                                    <Title className="form-title" order={2}>
                                        <div className='icone'>
                                            {GeneralTranslations.signal}
                                            <Tooltip
                                                multiline
                                                sx={{ maxWidth: 500 }}
                                                position="top"
                                                className="tooltip-konflikt"
                                                withArrow arrowSize={8} label={AlertTranslations.SinjalizimiTooltip} color="#051A53">
                                                <div className="icone2">
                                                    <FaInfoCircle size="18px" />
                                                </div>
                                            </Tooltip>
                                        </div>
                                    </Title>
                                    <div className="header-sinjalizimi">
                                        <Text className="form-desc" size="lg">
                                            <div className='icone'>
                                                {GeneralTranslations.SignalReportData}
                                                <Tooltip multiline sx={{ maxWidth: 500 }} withArrow arrowSize={8} label={AlertTranslations.SinjalizimDataTooltip} color="#051A53">
                                                    <div className="icone2">
                                                        <FaInfoCircle size="18px" />
                                                    </div>
                                                </Tooltip>
                                            </div>
                                        </Text>
                                        <AiOutlineArrowDown
                                            className={openedd ? "btn-sinjalizimi opened" : "btn-sinjalizimi"}
                                            onClick={() => setOpened(!openedd)}
                                        />
                                    </div>
                                </div>
                                <Collapse in={openedd}>
                                    <div className="collapse-sinjalzimi">
                                        <Group grow>
                                            <TextInput
                                                label={GeneralTranslations.name}
                                                name="raportuesiEmri"
                                                placeholder={GeneralTranslations.name}
                                                required
                                                onChange={formik.handleChange}
                                                value={formik.values.raportuesiEmri}
                                                onBlur={formik.handleBlur}
                                                error={formik.touched.raportuesiEmri && formik.errors.raportuesiEmri}
                                                inputWrapperOrder={['label', 'error', 'input']}
                                                rightSection={
                                                    <Tooltip withArrow arrowSize={8} label={AlertTranslations.SinjalizimiNameTooltip} color="#051A53">
                                                        <div className="icone">
                                                            <FaInfoCircle />
                                                        </div>
                                                    </Tooltip>
                                                }
                                            />
                                            <TextInput
                                                label={GeneralTranslations.lastName}
                                                name="raportuesiMbiemri"
                                                placeholder={GeneralTranslations.lastName}
                                                required
                                                onChange={formik.handleChange}
                                                value={formik.values.raportuesiMbiemri}
                                                onBlur={formik.handleBlur}
                                                error={formik.touched.raportuesiMbiemri && formik.errors.raportuesiMbiemri}
                                                inputWrapperOrder={['label', 'error', 'input']}
                                                rightSection={
                                                    <Tooltip withArrow arrowSize={8} label={AlertTranslations.SinjalizimiMbiemriTooltip} color="#051A53">
                                                        <div className="icone">
                                                            <FaInfoCircle />
                                                        </div>
                                                    </Tooltip>
                                                }
                                            />
                                        </Group>
                                        <TextInput
                                            label={GeneralTranslations.numriTelefonit}
                                            placeholder={GeneralTranslations.numriTelefonit}
                                            leftSectionPointerEvents="none"
                                            type="tel"
                                            name='raportuesiNrTel'
                                            onChange={(e) => formik.setFieldValue('raportuesiNrTel', e.target.value)}
                                            value={formik.values.raportuesiNrTel}
                                            leftSection={<MdOutlinePhoneEnabled />}
                                            rightSection={
                                                <Tooltip withArrow arrowSize={8} label={AlertTranslations.SinjalizimiTelTooltip} color="#051A53">
                                                    <div className="icone">
                                                        <FaInfoCircle />
                                                    </div>
                                                </Tooltip>
                                            }
                                        />
                                        <TextInput
                                            leftSectionPointerEvents="none"
                                            leftSection={<MdOutlineAlternateEmail />}
                                            label={GeneralTranslations.emailAddress}
                                            required
                                            name='raportuesiEmail'
                                            placeholder={GeneralTranslations.emailAddress}
                                            onChange={formik.handleChange}
                                            value={formik.values.raportuesiEmail}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.raportuesiEmail && formik.errors.raportuesiEmail}
                                            inputWrapperOrder={['label', 'error', 'input']}
                                            rightSection={
                                                <Tooltip withArrow arrowSize={8} label={AlertTranslations.SinjalizimiEmailTooltip} color="#051A53">
                                                    <div className="icone">
                                                        <FaInfoCircle />
                                                    </div>
                                                </Tooltip>
                                            }
                                        />
                                        <TextInput
                                            leftSectionPointerEvents="none"
                                            leftSection={<MdOutlineAlternateEmail />}
                                            label={ContentTranslations.ConfirmEmail}
                                            required
                                            name='ConfirmEmailRaportuesi'
                                            onChange={formik.handleChange}
                                            onPaste={handlePaste}
                                            value={formik.values.ConfirmEmailRaportuesi}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.raportuesiEmail && formik.errors.ConfirmEmailRaportuesi}
                                            placeholder={ContentTranslations.ConfirmEmail}
                                            inputWrapperOrder={['label', 'error', 'input']}
                                            rightSection={
                                                <Tooltip withArrow arrowSize={8} label={AlertTranslations.SinjalizimiEmailTooltip} color="#051A53">
                                                    <div className="icone">
                                                        <FaInfoCircle />
                                                    </div>
                                                </Tooltip>
                                            }
                                        />
                                        <Radio.Group
                                            label={
                                                <div className='icone'>
                                                    {GeneralTranslations.gender}
                                                    <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                                                    <Tooltip withArrow arrowSize={8} label={AlertTranslations.SinjalizimiGjiniaTooltip} color="#051A53">
                                                        <div className="icone2">
                                                            <FaInfoCircle />
                                                        </div>
                                                    </Tooltip>
                                                </div>}
                                            name='raportuesiGjiniaId'
                                            withAsterisk={false}
                                            value={formik.values.raportuesiGjiniaId}
                                            onChange={(value) => formik.setFieldValue('raportuesiGjiniaId', value)}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.raportuesiGjiniaId && formik.errors.raportuesiGjiniaId}
                                            inputWrapperOrder={['label', 'error', 'input']}
                                        >
                                            <Group mt="xs">
                                                <Radio color="#051A53" value="1" label="M" />
                                                <Radio color="#051A53" value="2" label="F" />
                                            </Group>
                                        </Radio.Group>
                                        <Values values={formik.values} />
                                        <Select
                                            searchable
                                            // clearable
                                            required
                                            key={WebsiteLanguage}
                                            data={institutionsDataWithStringValues}
                                            label={
                                                <div className='icone'>
                                                    {GeneralTranslations.institutionLabel}
                                                    <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                                                    <Tooltip withArrow arrowSize={8} label={AlertTranslations.SinjalizimiInstitucioniTooltip} color="#051A53">
                                                        <div className="icone2">
                                                            <FaInfoCircle />
                                                        </div>
                                                    </Tooltip>
                                                </div>}
                                            placeholder={GeneralTranslations.institutionLabel}
                                            name='raportuesiInstitucioniId'
                                            onChange={(selected) => {
                                                formik.setFieldValue('raportuesiInstitucioniId', selected);
                                            }}
                                            value={formik.values.raportuesiInstitucioniId}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.raportuesiInstitucioniId && formik.errors.raportuesiInstitucioniId}
                                            withAsterisk={false}
                                        />
                                        {formik.values.raportuesiInstitucioniId === '-1' && (
                                            <TextInput
                                                label={GeneralTranslations.institutionName}
                                                required
                                                placeholder={GeneralTranslations.institutionName}
                                                name='raportuesiInstitucioniTjera'
                                                onChange={formik.handleChange}
                                                value={formik.values.raportuesiInstitucioniTjera}
                                                onBlur={formik.handleBlur}
                                                error={formik.touched.raportuesiInstitucioniTjera && formik.errors.raportuesiInstitucioniTjera}
                                                inputWrapperOrder={['label', 'error', 'input']}
                                            />
                                        )}
                                    </div>
                                </Collapse>
                                <div className="form-section title-headings header-sinjalizimi">
                                    <Text className="form-desc" size="lg">
                                        <div className='icone'>
                                            {GeneralTranslations.SignalReportDataProcedure}
                                            <Tooltip withArrow arrowSize={8} label={AlertTranslations.SinjalizimZyrtarDataTooltip} color="#051A53">
                                                <div className="icone2">
                                                    <FaInfoCircle size="18px" />
                                                </div>
                                            </Tooltip>
                                        </div>
                                    </Text>
                                    <AiOutlineArrowDown
                                        className={openedZyrtari ? "btn-sinjalizimi opened" : "btn-sinjalizimi"}
                                        onClick={() => setOpenedZyrtari(!openedZyrtari)}
                                    />
                                </div>
                                <Collapse in={openedZyrtari}>
                                    <div className="collapse-sinjalzimi">
                                        <Group grow>
                                            <TextInput
                                                label={GeneralTranslations.name}
                                                name="emri"
                                                placeholder={GeneralTranslations.name}
                                                required
                                                onChange={(e) => {
                                                    setEmriList(e.target.value);
                                                    setEmriError(false)
                                                }}
                                                value={emriList}
                                                onBlur={formik.handleBlur}
                                                error={emriError ? `${ValidationTranslations.requiredField}` : ""}
                                                inputWrapperOrder={['label', 'error', 'input']}
                                                rightSection={
                                                    <Tooltip withArrow arrowSize={8} label={AlertTranslations.SinjalizimiName2Tooltip} color="#051A53">
                                                        <div className="icone">
                                                            <FaInfoCircle />
                                                        </div>
                                                    </Tooltip>
                                                }
                                            />
                                            <TextInput
                                                label={GeneralTranslations.lastName}
                                                placeholder={GeneralTranslations.lastName}
                                                name="mbiemri"
                                                required
                                                onChange={(e) => {
                                                    setMbiemriList(e.target.value)
                                                    setMbiemriError(false)
                                                }}
                                                value={mbimeriList}
                                                onBlur={formik.handleBlur}
                                                error={mbimeriError ? `${ValidationTranslations.requiredField}` : ""}
                                                inputWrapperOrder={['label', 'error', 'input']}
                                                rightSection={
                                                    <Tooltip withArrow arrowSize={8} label={AlertTranslations.SinjalizimiMbiemri2Tooltip} color="#051A53">
                                                        <div className="icone">
                                                            <FaInfoCircle />
                                                        </div>
                                                    </Tooltip>
                                                }
                                            />
                                        </Group>
                                        <TextInput
                                            label={GeneralTranslations.numriTelefonit}
                                            placeholder={GeneralTranslations.numriTelefonit}
                                            leftSectionPointerEvents="none"
                                            type="nrTel"
                                            name='nrTel'
                                            onChange={(e) => setNrTelList(e.target.value)}
                                            value={nrtelList}
                                            leftSection={<MdOutlinePhoneEnabled />}
                                            inputWrapperOrder={['label', 'error', 'input']}
                                            rightSection={
                                                <Tooltip withArrow arrowSize={8} label={AlertTranslations.SinjalizimiTel2Tooltip} color="#051A53">
                                                    <div className="icone">
                                                        <FaInfoCircle />
                                                    </div>
                                                </Tooltip>
                                            }
                                        />
                                        <TextInput
                                            leftSectionPointerEvents="none"
                                            leftSection={<MdOutlineAlternateEmail />}
                                            label={GeneralTranslations.emailAddress}
                                            placeholder={GeneralTranslations.emailAddress}
                                            name='email'
                                            onChange={handleEmailChange}
                                            value={emailList}
                                            error={emailError ? `${ValidationTranslations.validEmail}` : ''}
                                            inputWrapperOrder={['label', 'error', 'input']}
                                            rightSection={
                                                <Tooltip withArrow arrowSize={8} label={AlertTranslations.SinjalizimiEmail2Tooltip} color="#051A53">
                                                    <div className="icone">
                                                        <FaInfoCircle />
                                                    </div>
                                                </Tooltip>
                                            }
                                        />
                                        <Radio.Group
                                            label={
                                                <div className='icone'>
                                                    {GeneralTranslations.gender}
                                                    <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                                                    <Tooltip multiline w={300} withArrow arrowSize={8} label={AlertTranslations.SinjalizimiGjiniaM2Tooltip} color="#051A53">
                                                        <div className="icone2">
                                                            <FaInfoCircle />
                                                        </div>
                                                    </Tooltip>
                                                </div>}
                                            name='gjiniaId'
                                            value={gjiniaList}
                                            onChange={(value) => {
                                                setGjiniaList(value)
                                                setGjiniaError(false)
                                            }}
                                            onBlur={formik.handleBlur}
                                            error={gjiniaError ? `${ValidationTranslations.requiredField}` : ""}
                                            inputWrapperOrder={['label', 'error', 'input']}
                                            withAsterisk={false}
                                        >
                                            <Group mt="xs">
                                                <Radio color="#051A53" value="1" label="M" />
                                                <Radio color="#051A53" value="2" label="F" />
                                            </Group>
                                        </Radio.Group>
                                        <Select
                                            searchable
                                            // clearable
                                            required
                                            key={WebsiteLanguage}
                                            data={institutionsDataWithStringValues}
                                            label={
                                                <div className='icone'>
                                                    {GeneralTranslations.institutionLabel}
                                                    <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                                                    <Tooltip withArrow arrowSize={8} label={AlertTranslations.SinjalizimiInstitucioniTooltip} color="#051A53">
                                                        <div className="icone2">
                                                            <FaInfoCircle />
                                                        </div>
                                                    </Tooltip>
                                                </div>}
                                            placeholder={GeneralTranslations.institutionLabel}
                                            name='institucioniId'
                                            onChange={(selectedId) => {
                                                const selectedItem = institutionsDataWithStringValues.find(item => item.value === selectedId);

                                                if (selectedItem) {
                                                    setInstituconiList({ id: selectedItem.value, label: selectedItem.label });
                                                } else {
                                                    setInstituconiList(null);
                                                }

                                                setInstituconiError(false);
                                            }}
                                            value={instutucioniList && instutucioniList.id}
                                            onBlur={formik.handleBlur}
                                            error={instutucioniError ? `${ValidationTranslations.requiredField}` : ""}
                                            withAsterisk={false}
                                        />
                                        {instutucioniList?.id === '-1' && (
                                            <TextInput
                                                label={GeneralTranslations.institutionName}
                                                required
                                                placeholder={GeneralTranslations.institutionName}
                                                name='institucioniTjera'
                                                onChange={(e) => {
                                                    setInstutucioniTjeterList(e.target.value);
                                                    setInstutucioniTjeterError(false);
                                                }}
                                                value={instutucioniTjeterList}
                                                onBlur={formik.handleBlur}
                                                error={instutucioniTjeterError ? `${ValidationTranslations.requiredField}` : ""}
                                                inputWrapperOrder={['label', 'error', 'input']}
                                            />
                                        )}
                                        <TextInput
                                            label={GeneralTranslations.jobPosition}
                                            placeholder={GeneralTranslations.jobPosition}
                                            required
                                            name='pozitaPunes'
                                            onChange={(e) => {
                                                setPozitaPunesList(e.target.value);
                                                setPozitaPunesError(false);
                                            }}
                                            value={pozitaPunesList}
                                            onBlur={formik.handleBlur}
                                            error={pozitaPunesError ? `${ValidationTranslations.requiredField}` : ""}
                                            inputWrapperOrder={['label', 'error', 'input']}
                                            rightSection={
                                                <Tooltip withArrow arrowSize={8} label={AlertTranslations.SinjalizimiJobTooltip} color="#051A53">
                                                    <div className="icone">
                                                        <FaInfoCircle />
                                                    </div>
                                                </Tooltip>
                                            }
                                        />
                                    </div>
                                </Collapse>
                                <Button className="button-zyrtari" onClick={handleSaveZyrtari}>
                                    {GeneralTranslations.AddZyrtar}
                                </Button>

                                {zyrtariList.length > 0 && (
                                    <div className='document-list'>
                                        <Table sx={{ minWidth: 300 }} aria-label="simple table" className="table-raportimet">
                                            <TableHead>
                                                <TableRow className="header-table">
                                                    <TableCell className="header-th">{GeneralTranslations.numberTable}</TableCell>
                                                    <TableCell className="header-th">{GeneralTranslations.name}</TableCell>
                                                    <TableCell className="header-th">{GeneralTranslations.lastName}</TableCell>
                                                    <TableCell className="header-th">{GeneralTranslations.institutionLabel}</TableCell>
                                                    <TableCell className="header-th"></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {zyrtariList.map((zyrtari, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell>{index + 1}</TableCell>
                                                        <TableCell>{zyrtari.emri}</TableCell>
                                                        <TableCell>{zyrtari.mbiemri}</TableCell>
                                                        <TableCell> {zyrtari.institucioniId === '-1' || zyrtari.institucioniId === null ?
                                                            (zyrtari.institucioniTjera) :
                                                            (zyrtari.institucioniName)}
                                                        </TableCell>
                                                        <TableCell><Button size='xs' className="btn-clear-table" onClick={() => handleDeleteZyrtari(index)} variant="filled" >{ControlsTranslations.Delete}</Button></TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </div>
                                )}
                            </div>
                        </Stepper.Step>
                        <Stepper.Step label={ContentTranslations.step2Name} description={ContentTranslations.sinjalizimiStep2Description}>
                            <div className="form-container">
                                <div className="form-section">
                                    <Title className="form-title" order={2}>{GeneralTranslations.signal}</Title>
                                    <Text className="form-desc" size="lg">{GeneralTranslations.sinjalizimiStep2subTitle}</Text>
                                </div>
                                <Values values={formik.values} />

                                <Radio.Group
                                    label={
                                        <div className='icone'>
                                            {GeneralTranslations.signalContent}
                                            <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                                            <Tooltip multiline w={500} withArrow arrowSize={8} label={AlertTranslations.SinjalizimiPershkrimiTooltip} color="#051A53">
                                                <div className="icone2">
                                                    <FaInfoCircle />
                                                </div>
                                            </Tooltip>
                                        </div>}
                                    className='radio-column'
                                    name='permbajtjaSinjalizimiId'
                                    value={formik.values.permbajtjaSinjalizimiId}
                                    onChange={(value) => formik.setFieldValue('permbajtjaSinjalizimiId', value)}
                                    withAsterisk={false}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.permbajtjaSinjalizimiId && formik.errors.permbajtjaSinjalizimiId}
                                    inputWrapperOrder={['label', 'error', 'input']}
                                >
                                    <Group mt="xs">
                                        {permbajtja.map((option, index) => (
                                            <Radio color="#051A53" key={index} value={`${option.id}`} label={option[pershkrimiLocale]} />
                                        ))}
                                    </Group>
                                </Radio.Group>
                                {formik.values.permbajtjaSinjalizimiId && (
                                    <Fragment>
                                        <Textarea
                                            rows={6}
                                            label={GeneralTranslations.descriptionPermbatja}
                                            placeholder={GeneralTranslations.descriptionPermbatja}
                                            name="permbajtjaSinjalizimiPershkrimi"
                                            onChange={(e) => {
                                                if (e.target.value.length <= maxChars) {
                                                    formik.handleChange(e);
                                                }
                                            }}
                                            value={formik.values.permbajtjaSinjalizimiPershkrimi}
                                            onBlur={formik.handleBlur}
                                        />
                                        <Text size="sm" color={formik.values.permbajtjaSinjalizimiPershkrimi?.length === maxChars ? 'red' : 'gray'} style={{ marginTop: 4 }}>
                                            {formik.values.permbajtjaSinjalizimiPershkrimi?.length}/{maxChars}
                                        </Text>
                                    </Fragment>
                                )}
                                <Radio.Group
                                    label={GeneralTranslations.internalSignal}
                                    withAsterisk
                                    name='sinjalizimiBrendshemKryer'
                                    value={formik.values.sinjalizimiBrendshemKryer}
                                    onChange={(value) => formik.setFieldValue('sinjalizimiBrendshemKryer', value)}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.sinjalizimiBrendshemKryer && formik.errors.sinjalizimiBrendshemKryer}
                                    inputWrapperOrder={['label', 'error', 'input']}
                                >
                                    <Group mt="xs">
                                        <Radio color="#051A53" value="true" label={ControlsTranslations.yes} />
                                        <Radio color="#051A53" value="false" label={ControlsTranslations.no} />
                                    </Group>
                                </Radio.Group>
                                {formik.values.sinjalizimiBrendshemKryer === 'true' ? (

                                    <Fragment>
                                        <DateInput
                                            className="form-dateInput"
                                            valueFormat="DD/MM/YYYY"
                                            label={GeneralTranslations.signalDate}
                                            placeholder="DD/MM/YYYY"
                                            clearable
                                            leftSectionPointerEvents="none"
                                            leftSection={<MdOutlineDateRange />}
                                            name='dataSinjalizimit'
                                            selected={formik.values.dataSinjalizimit}
                                            value={formik.values.dataSinjalizimit}
                                            onChange={(date) => formik.setFieldValue('dataSinjalizimit', date)}
                                            inputWrapperOrder={['label', 'error', 'input']}
                                            rightSection={
                                                <Tooltip withArrow arrowSize={8} label={AlertTranslations.SinjalizimiDateTooltip} color="#051A53">
                                                    <div className="icone">
                                                        <FaInfoCircle />
                                                    </div>
                                                </Tooltip>
                                            }
                                        />
                                        <Radio.Group
                                            name="SinjalizimitEshteBereTe"
                                            label={
                                                <div className='icone'>
                                                    {GeneralTranslations.doneSignal}
                                                    <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                                                    <Tooltip withArrow arrowSize={8} label={AlertTranslations.SinjalizimiToTooltip} color="#051A53">
                                                        <div className="icone2">
                                                            <FaInfoCircle />
                                                        </div>
                                                    </Tooltip>
                                                </div>
                                            }
                                            withAsterisk={false}
                                            value={formik.values.SinjalizimitEshteBereTe}
                                            onChange={(value) => formik.setFieldValue('SinjalizimitEshteBereTe', value)}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.SinjalizimitEshteBereTe && formik.errors.SinjalizimitEshteBereTe}
                                            inputWrapperOrder={['label', 'error', 'input']}
                                        >
                                            <Group mt="xs">
                                                <Radio color="#051A53" value="1" label={GeneralTranslations.official} />
                                                <Radio color="#051A53" value="2" label={GeneralTranslations.employer} />
                                            </Group>
                                        </Radio.Group>
                                        <Radio.Group
                                            name="epiloguId"
                                            label={
                                                <div className='icone'>
                                                    {GeneralTranslations.epilogu}
                                                    <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                                                    <Tooltip multiline w={350} withArrow arrowSize={8} label={AlertTranslations.SinjalizimiEpiloguTooltip} color="#051A53">
                                                        <div className="icone2">
                                                            <FaInfoCircle />
                                                        </div>
                                                    </Tooltip>
                                                </div>}
                                            className='radio-column'
                                            withAsterisk={false}
                                            value={formik.values.epiloguId}
                                            onChange={(value) => formik.setFieldValue('epiloguId', value)}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.epiloguId && formik.errors.epiloguId}
                                            inputWrapperOrder={['label', 'error', 'input']}
                                        >
                                            <Group mt="xs">
                                                {epilogu.map((option, index) => (
                                                    <Radio color="#051A53" key={index} value={`${option.id}`} label={option[nameLocale]} />
                                                ))}
                                            </Group>
                                        </Radio.Group>
                                    </Fragment>
                                ) : formik.values.sinjalizimiBrendshemKryer === 'false' ? (
                                    <Fragment>
                                        <Textarea
                                            rows={6}
                                            label={
                                                <div className='icone'>
                                                    {GeneralTranslations.reasonReport}
                                                    <Tooltip withArrow arrowSize={8} label={AlertTranslations.SinjalizimiBrenshemTooltip} color="#051A53">
                                                        <div className="icone2">
                                                            <FaInfoCircle />
                                                        </div>
                                                    </Tooltip>
                                                </div>}
                                            placeholder={GeneralTranslations.reasonReport}
                                            name='sinjalizimiBrendshemPaKryerKoment'
                                            onChange={(e) => {
                                                if (e.target.value.length <= maxChars) {
                                                    formik.handleChange(e);
                                                }
                                            }}
                                            value={formik.values.sinjalizimiBrendshemPaKryerKoment}
                                            error={formik.touched.sinjalizimiBrendshemPaKryerKoment && formik.errors.sinjalizimiBrendshemPaKryerKoment}
                                            inputWrapperOrder={['label', 'error', 'input']}
                                            onBlur={formik.handleBlur}
                                        />
                                        <Text size="sm" color={formik.values.sinjalizimiBrendshemPaKryerKoment?.length === maxChars ? 'red' : 'gray'} style={{ marginTop: 4 }}>
                                            {formik.values.sinjalizimiBrendshemPaKryerKoment?.length}/{maxChars}
                                        </Text>
                                    </Fragment>
                                ) : (
                                    ''
                                )}
                                <div className="form-section title-headings">
                                    <Text className="form-desc" size="lg">
                                        <div className='icone'>
                                            {GeneralTranslations.listDocument}
                                            <Tooltip multiline w={500} withArrow arrowSize={8} label={AlertTranslations.SinjalizimiDokumentetTooltip} color="#051A53">
                                                <div className="icone2">
                                                    <FaInfoCircle />
                                                </div>
                                            </Tooltip>
                                        </div></Text>
                                </div>
                                <Group mt="xs">
                                    <UploadFile onFileChange={handleFileChange} />
                                    <Group className="doc-group">
                                        <TextInput
                                            leftSectionPointerEvents="none"
                                            leftSection={selectedFile ? <GrDocumentText /> : null}
                                            placeholder={GeneralTranslations.documentName}
                                            rightSection={
                                                selectedFile ? (
                                                    <CloseButton size="sm" variant="transparent" onClick={clearInputValue} />
                                                ) : null
                                            }
                                            className='doc-input'
                                            value={documentName}
                                            error={selectedFileError ? `${checkMediaError ? AlertTranslations.CheckMediaErrorAlert : AlertTranslations.notifyFileRequiredInput}` : ""}
                                            onChange={(e) => setDocumentName(e.target.value)}
                                        />
                                        {selectedFile &&
                                            <Button className="btn-add-doc form-btn btn-search-report" type="button" color="#051A53" onClick={handleSave}>{ControlsTranslations.Add}</Button>
                                        }
                                        <Tooltip withArrow arrowSize={8} label={AlertTranslations.MediaAllowedTooltip} color="#051A53">
                                            <div className="icone2">
                                                <FaInfoCircle size="18px" />
                                            </div>
                                        </Tooltip>
                                        {/* {selectedFile &&
                                            <ActionIcon color="#051A53" onClick={handleSave}><FaRegSave /></ActionIcon>
                                        } */}

                                    </Group>
                                </Group>
                                {savedDocuments.length > 0 && (
                                    <div className='document-list'>
                                        <Table sx={{ minWidth: 300 }} aria-label="simple table" className="table-raportimet">
                                            <TableHead>
                                                <TableRow className="header-table">
                                                    <TableCell className="header-th">{GeneralTranslations.numberTable}</TableCell>
                                                    <TableCell className="header-th">{GeneralTranslations.documentNameTable}</TableCell>
                                                    <TableCell className="header-th"></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {savedDocuments.map((doc, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell >{index + 1}</TableCell>
                                                        <TableCell >{doc.file.name}</TableCell>
                                                        <TableCell ><Button size='xs' className="btn-clear-table" onClick={() => handleDelete(index)} >{ControlsTranslations.Delete}</Button></TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </div>
                                )}
                            </div>
                        </Stepper.Step>
                        <Stepper.Completed>
                            <div className="form-container">
                                <div className="form-section">
                                    <Title className="form-title" order={2}>{GeneralTranslations.signal}</Title>
                                    <Text className="form-desc" size="lg">{GeneralTranslations.sinjalizimiStep2subTitle}</Text>
                                </div>
                                <Values values={formik.values} />

                                <Radio.Group
                                    label={
                                        <div className='icone'>
                                            {GeneralTranslations.signalContent}
                                            <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                                            <Tooltip multiline w={500} withArrow arrowSize={8} label={AlertTranslations.SinjalizimiPershkrimiTooltip} color="#051A53">
                                                <div className="icone2">
                                                    <FaInfoCircle />
                                                </div>
                                            </Tooltip>
                                        </div>}
                                    className='radio-column'
                                    name='permbajtjaSinjalizimiId'
                                    value={formik.values.permbajtjaSinjalizimiId}
                                    onChange={(value) => formik.setFieldValue('permbajtjaSinjalizimiId', value)}
                                    withAsterisk={false}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.permbajtjaSinjalizimiId && formik.errors.permbajtjaSinjalizimiId}
                                    inputWrapperOrder={['label', 'error', 'input']}
                                >
                                    <Group mt="xs">
                                        {permbajtja.map((option, index) => (
                                            <Radio color="#051A53" key={index} value={`${option.id}`} label={option[pershkrimiLocale]} />
                                        ))}
                                    </Group>
                                </Radio.Group>
                                {formik.values.permbajtjaSinjalizimiId && (
                                    <Fragment>
                                        <Textarea
                                            rows={6}
                                            label={GeneralTranslations.descriptionPermbatja}
                                            placeholder={GeneralTranslations.descriptionPermbatja}
                                            name="permbajtjaSinjalizimiPershkrimi"
                                            onChange={(e) => {
                                                if (e.target.value.length <= maxChars) {
                                                    formik.handleChange(e);
                                                }
                                            }}
                                            value={formik.values.permbajtjaSinjalizimiPershkrimi}
                                            onBlur={formik.handleBlur}
                                        />
                                        <Text size="sm" color={formik.values.permbajtjaSinjalizimiPershkrimi?.length === maxChars ? 'red' : 'gray'} style={{ marginTop: 4 }}>
                                            {formik.values.permbajtjaSinjalizimiPershkrimi?.length}/{maxChars}
                                        </Text>
                                    </Fragment>
                                )}
                                <Radio.Group
                                    label={GeneralTranslations.internalSignal}
                                    withAsterisk
                                    name='sinjalizimiBrendshemKryer'
                                    value={formik.values.sinjalizimiBrendshemKryer}
                                    onChange={(value) => formik.setFieldValue('sinjalizimiBrendshemKryer', value)}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.sinjalizimiBrendshemKryer && formik.errors.sinjalizimiBrendshemKryer}
                                    inputWrapperOrder={['label', 'error', 'input']}
                                >
                                    <Group mt="xs">
                                        <Radio color="#051A53" value="true" label={ControlsTranslations.yes} />
                                        <Radio color="#051A53" value="false" label={ControlsTranslations.no} />
                                    </Group>
                                </Radio.Group>
                                {formik.values.sinjalizimiBrendshemKryer === 'true' ? (

                                    <Fragment>
                                        <DateInput
                                            className="form-dateInput"
                                            valueFormat="DD/MM/YYYY"
                                            label={GeneralTranslations.signalDate}
                                            placeholder="DD/MM/YYYY"
                                            clearable
                                            leftSectionPointerEvents="none"
                                            leftSection={<MdOutlineDateRange />}
                                            name='dataSinjalizimit'
                                            selected={formik.values.dataSinjalizimit}
                                            value={formik.values.dataSinjalizimit}
                                            onChange={(date) => formik.setFieldValue('dataSinjalizimit', date)}
                                            inputWrapperOrder={['label', 'error', 'input']}
                                            rightSection={
                                                <Tooltip withArrow arrowSize={8} label={AlertTranslations.SinjalizimiDateTooltip} color="#051A53">
                                                    <div className="icone">
                                                        <FaInfoCircle />
                                                    </div>
                                                </Tooltip>
                                            }
                                        />
                                        <Radio.Group
                                            name="SinjalizimitEshteBereTe"
                                            label={
                                                <div className='icone'>
                                                    {GeneralTranslations.doneSignal}
                                                    <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                                                    <Tooltip withArrow arrowSize={8} label={AlertTranslations.SinjalizimiToTooltip} color="#051A53">
                                                        <div className="icone2">
                                                            <FaInfoCircle />
                                                        </div>
                                                    </Tooltip>
                                                </div>
                                            }
                                            withAsterisk={false}
                                            value={formik.values.SinjalizimitEshteBereTe}
                                            onChange={(value) => formik.setFieldValue('SinjalizimitEshteBereTe', value)}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.SinjalizimitEshteBereTe && formik.errors.SinjalizimitEshteBereTe}
                                            inputWrapperOrder={['label', 'error', 'input']}
                                        >
                                            <Group mt="xs">
                                                <Radio color="#051A53" value="1" label={GeneralTranslations.official} />
                                                <Radio color="#051A53" value="2" label={GeneralTranslations.employer} />
                                            </Group>
                                        </Radio.Group>
                                        <Radio.Group
                                            name="epiloguId"
                                            label={
                                                <div className='icone'>
                                                    {GeneralTranslations.epilogu}
                                                    <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                                                    <Tooltip multiline w={350} withArrow arrowSize={8} label={AlertTranslations.SinjalizimiEpiloguTooltip} color="#051A53">
                                                        <div className="icone2">
                                                            <FaInfoCircle />
                                                        </div>
                                                    </Tooltip>
                                                </div>}
                                            className='radio-column'
                                            withAsterisk={false}
                                            value={formik.values.epiloguId}
                                            onChange={(value) => formik.setFieldValue('epiloguId', value)}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.epiloguId && formik.errors.epiloguId}
                                            inputWrapperOrder={['label', 'error', 'input']}
                                        >
                                            <Group mt="xs">
                                                {epilogu.map((option, index) => (
                                                    <Radio color="#051A53" key={index} value={`${option.id}`} label={option[nameLocale]} />
                                                ))}
                                            </Group>
                                        </Radio.Group>
                                    </Fragment>
                                ) : formik.values.sinjalizimiBrendshemKryer === 'false' ? (
                                    <Fragment>
                                        <Textarea
                                            rows={6}
                                            label={
                                                <div className='icone'>
                                                    {GeneralTranslations.reasonReport}
                                                    <Tooltip withArrow arrowSize={8} label={AlertTranslations.SinjalizimiBrenshemTooltip} color="#051A53">
                                                        <div className="icone2">
                                                            <FaInfoCircle />
                                                        </div>
                                                    </Tooltip>
                                                </div>}
                                            placeholder={GeneralTranslations.reasonReport}
                                            name='sinjalizimiBrendshemPaKryerKoment'
                                            onChange={(e) => {
                                                if (e.target.value.length <= maxChars) {
                                                    formik.handleChange(e);
                                                }
                                            }}
                                            value={formik.values.sinjalizimiBrendshemPaKryerKoment}
                                            error={formik.touched.sinjalizimiBrendshemPaKryerKoment && formik.errors.sinjalizimiBrendshemPaKryerKoment}
                                            inputWrapperOrder={['label', 'error', 'input']}
                                            onBlur={formik.handleBlur}
                                        />
                                        <Text size="sm" color={formik.values.sinjalizimiBrendshemPaKryerKoment?.length === maxChars ? 'red' : 'gray'} style={{ marginTop: 4 }}>
                                            {formik.values.sinjalizimiBrendshemPaKryerKoment?.length}/{maxChars}
                                        </Text>
                                    </Fragment>
                                ) : (
                                    ''
                                )}
                                <div className="form-section title-headings">
                                    <Text className="form-desc" size="lg">
                                        <div className='icone'>
                                            {GeneralTranslations.listDocument}
                                            <Tooltip multiline w={500} withArrow arrowSize={8} label={AlertTranslations.SinjalizimiDokumentetTooltip} color="#051A53">
                                                <div className="icone2">
                                                    <FaInfoCircle />
                                                </div>
                                            </Tooltip>
                                        </div></Text>
                                </div>
                                <Group mt="xs">
                                    <UploadFile onFileChange={handleFileChange} />
                                    <Group className="doc-group">
                                        <TextInput
                                            leftSectionPointerEvents="none"
                                            leftSection={selectedFile ? <GrDocumentText /> : null}
                                            placeholder={GeneralTranslations.documentName}
                                            rightSection={
                                                selectedFile ? (
                                                    <CloseButton size="sm" variant="transparent" onClick={clearInputValue} />
                                                ) : null
                                            }
                                            className='doc-input'
                                            error={selectedFileError ? `${checkMediaError ? AlertTranslations.CheckMediaErrorAlert : AlertTranslations.notifyFileRequiredInput}` : ""}
                                            value={documentName}
                                            onChange={(e) => setDocumentName(e.target.value)}
                                        />
                                        {selectedFile &&
                                            <Button className="btn-add-doc form-btn btn-search-report" type="button" color="#051A53" onClick={handleSave}>{ControlsTranslations.Add}</Button>
                                        }
                                        <Tooltip withArrow arrowSize={8} label={AlertTranslations.MediaAllowedTooltip} color="#051A53">
                                            <div className="icone2">
                                                <FaInfoCircle size="18px" />
                                            </div>
                                        </Tooltip>
                                        {/* {selectedFile &&
                                            <ActionIcon color="#051A53" onClick={handleSave}><FaRegSave /></ActionIcon>
                                        } */}

                                    </Group>
                                </Group>
                                {savedDocuments.length > 0 && (
                                    <div className='document-list'>
                                        <Table sx={{ minWidth: 300 }} aria-label="simple table" className="table-raportimet">
                                            <TableHead>
                                                <TableRow className="header-table">
                                                    <TableCell className="header-th">{GeneralTranslations.numberTable}</TableCell>
                                                    <TableCell className="header-th">{GeneralTranslations.documentNameTable}</TableCell>
                                                    <TableCell className="header-th"></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {savedDocuments.map((doc, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell >{index + 1}</TableCell>
                                                        <TableCell >{doc.file.name}</TableCell>
                                                        <TableCell ><Button size='xs' className="btn-clear-table" onClick={() => handleDelete(index)} >{ControlsTranslations.Delete}</Button></TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </div>
                                )}
                            </div>
                        </Stepper.Completed>
                    </Stepper>
                    <div className="apk-form-background">
                        <div className='logo'> <img src="/img/logo/web/logo-gray.png" alt="Logo" /></div>
                    </div>
                    <Link className='back-btn' to="/">{GeneralTranslations.BackToHome}</Link>
                </div>
                <div className="stepper-footer">
                    <Group justify="end" mt="xl">
                        {active >= 1 &&
                            <Button type="button" className="form-btn-back btn-base" variant="default" onClick={prevStep}>{ControlsTranslations.BackButton2}</Button>
                        }
                        <Button
                            type="submit"
                            leftSection={active === 2 && <FaCheck />}
                            className="form-btn btn-base"
                            onClick={() => {
                                handleNextStep();
                            }}
                            disabled={isLoading}
                        >
                            {isLoading ? ControlsTranslations.generating : active === 2 ? ControlsTranslations.finished : active === 1 ? ControlsTranslations.Send : ControlsTranslations.continue}
                        </Button>
                    </Group>
                </div>
            </div>
            {
                active === 2 && referenceSinjalizimi &&
                <Modal
                    className="raport-modal"
                    opened={true}
                    centered
                    size="lg"
                    withCloseButton={false}
                    // onClose={close}
                    overlayProps={{
                        backgroundOpacity: 0.55,
                        blur: 3,
                    }}
                >
                    <div className="completed-step">
                        <div className="completed-box">
                            <div className="text-content">
                                <Title className="form-title" order={2}>{GeneralTranslations.succes}</Title>
                                <Text className="form-desc" size="md">
                                    {GeneralTranslations.subjectNumber}
                                    <CopyToClipboard text={referenceSinjalizimi}>
                                        <Text
                                            td="underline"
                                            span
                                            c="blue"
                                            inherit
                                            onClick={() => {
                                                setTooltipVisible(true);
                                                setTimeout(() => setTooltipVisible(false), 2000);
                                            }}
                                        >
                                            {referenceSinjalizimi}
                                        </Text>
                                    </CopyToClipboard>
                                    {/* {tooltipVisible && <div className="tooltip-web">Copied</div>} */}
                                </Text>
                            </div>
                            <div className="completed-footer">
                                <Group justify="end">
                                    <Button className="form-btn-back btn-base">
                                        <a
                                            href={`${baseUrl}Reports/GetSignalReport?type=1&ReferencaRaportimit=${referenceSinjalizimi}&webLangId=${languageValue}`}
                                            target="_blank"
                                        >
                                            {ControlsTranslations.download}
                                        </a>
                                    </Button>
                                    <Button className="form-btn btn-base" variant="default" onClick={handlePopup}>{ControlsTranslations.finish}</Button>
                                </Group>

                            </div>

                        </div>
                    </div>
                </Modal>
            }
            <Modal
                className="raport-modal"
                opened={zyrtariModalOpen}
                centered
                size="lg"
                withCloseButton={false}
                onClose={closeModalZyrtari}
                overlayProps={{
                    backgroundOpacity: 0.55,
                    blur: 3,
                }}
            >
                <div className="completed-step">
                    <div className="completed-box">
                        <div className="text-content">
                            <Title className="form-title flex items-center gap-2" order={2}><FaInfoCircle color='#051A53' />  {AlertTranslations.AreYouSure}</Title>
                            <Text className="form-desc" size="md">
                                {AlertTranslations.AreYouSureDescription}
                            </Text>
                        </div>
                        <div className="completed-footer">
                            <Group justify="end">
                                <Button className="form-btn-back btn-base" variant="outline" onClick={closeModalZyrtari}>
                                    {ControlsTranslations.no}
                                </Button>
                                <Button className="form-btn btn-base" variant="default" color="red" onClick={confirmDeleteZyrtari}>
                                    {ControlsTranslations.yes}
                                </Button>
                            </Group>

                        </div>
                    </div>
                </div>
            </Modal>
            <Modal
                className="raport-modal"
                opened={documentsModelOpen}
                centered
                size="lg"
                withCloseButton={false}
                onClose={closeModalDocuments}
                overlayProps={{
                    backgroundOpacity: 0.55,
                    blur: 3,
                }}
            >
                <div className="completed-step">
                    <div className="completed-box">
                        <div className="text-content">
                            <Title className="form-title flex items-center gap-2" order={2}><FaInfoCircle color='#051A53' />  {AlertTranslations.AreYouSure}</Title>
                            <Text className="form-desc" size="md">
                                {AlertTranslations.AreYouSureDescription}
                            </Text>
                        </div>
                        <div className="completed-footer">
                            <Group justify="end">
                                <Button className="form-btn-back btn-base" variant="outline" onClick={closeModalDocuments}>
                                    {ControlsTranslations.no}
                                </Button>
                                <Button className="form-btn btn-base" variant="default" color="red" onClick={confirmDeleteDocuments}>
                                    {ControlsTranslations.yes}
                                </Button>
                            </Group>

                        </div>
                    </div>
                </div>
            </Modal>
            <div className="notification-cm">
                {NotificationBox}
            </div>
        </div >
    );
}

export default Sinjalizimi